import { render, staticRenderFns } from "./DepartamentoCRUD.vue?vue&type=template&id=7e5f0fcc"
import script from "./DepartamentoCRUD.vue?vue&type=script&lang=js"
export * from "./DepartamentoCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports